import * as Sentry from '@sentry/vue'

/**
 * Validates that all rows in chartData have the same column count as the header row.
 * Returns the data array if valid, or null if malformed.
 */
export function validateChartData(data) {
  if (!Array.isArray(data) || data.length < 2 || !Array.isArray(data[0])) return null
  const columnCount = data[0].length
  for (let i = 1; i < data.length; i++) {
    if (!Array.isArray(data[i]) || data[i].length !== columnCount) return null
  }
  return data
}

/**
 * Reports malformed chart data to Sentry with diagnostic info.
 * @param {Array} data - The raw chartData array
 * @param {Object} context - Object with dashUuid and/or namespace
 */
export function reportMalformedChartData(data, context) {
  if (!Array.isArray(data) || data.length < 2) return
  if (!Array.isArray(data[0])) {
    Sentry.captureException(new Error('Malformed chart data: header row is not an array'), {
      extra: { headerRow: data[0], totalRows: data.length, ...context }
    })
    return
  }
  const headerRow = data[0]
  const badRows = []
  for (let i = 1; i < data.length; i++) {
    if (!Array.isArray(data[i]) || data[i].length !== headerRow.length) {
      badRows.push({ index: i, columns: Array.isArray(data[i]) ? data[i].length : 0, sample: data[i] })
      if (badRows.length >= 3) break
    }
  }
  Sentry.captureException(new Error('Malformed chart data: row column count mismatch'), {
    extra: {
      expectedColumns: headerRow.length,
      headerRow,
      totalRows: data.length,
      badRows,
      ...context
    }
  })
}
